import {CriterionName, ICriterion, TagLabel} from '@/entities'

export type TagValue = ICriterion<CriterionName>[] | [number?, number?] | number | string
export type TagType = 'range' | 'value' | 'criterion' | ''

export interface ITagLabelData {
  label: string
  remainder?: number
}

export interface ITagLabel extends ITagLabelData {
  remainder: number
}

export interface ITagData {
  name: string
  value: TagValue
  type?: TagType
}

export interface ITag extends ITagData {
  type: TagType
  representation: TagLabel
  shortRepresentation: TagLabel
}

export const TAG_REPRESENTATION_MAX_LABELS = 1;
